export default __webpack_public_path__ + "static/media/graphic_5.9796050e.svg";